import { Button, Card, Form, Input, message, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ContentWithErrorHandler from '../../app/ContentWithErrorHandler';
import { useCreateUmkmCategoryMutation, useGetUmkmCategoryQuery, useUpdateUmkmCategoryMutation } from './umkmCategoryAPI';
import { UploadFile } from 'antd/lib/upload/interface';

const { TextArea } = Input;

function UmkmCategoryDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const { data, error, isLoading } = useGetUmkmCategoryQuery(id!, { skip: !id });
  const [createCategory] = useCreateUmkmCategoryMutation();
  const [updateCategory] = useUpdateUmkmCategoryMutation();

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        name: data.name,
        description: data.description,
      });
      if (data.image) {
        setFileList([
          {
            uid: '-1',
            name: 'image',
            status: 'done',
            url: data.image,
          },
        ]);
      }
    }
  }, [data, form]);

  const onFinish = async (values: any) => {
    try {
      const formData = new FormData();
      formData.append('name', values.name);
      if (values.description) {
        formData.append('description', values.description);
      }

      if (fileList.length > 0 && fileList[0].originFileObj) {
        formData.append('file', fileList[0].originFileObj);
      }

      if (id) {
        formData.append('id', id);
        await updateCategory(formData).unwrap();
        message.success('Kategori berhasil diupdate');
      } else {
        await createCategory(formData).unwrap();
        message.success('Kategori berhasil dibuat');
      }
      navigate('/umkm-category');
    } catch (error) {
      message.error('Gagal menyimpan kategori');
    }
  };

  return (
    <ContentWithErrorHandler isError={error} isLoading={isLoading}>
      <Card title={id ? 'Edit Kategori UMKM' : 'Tambah Kategori UMKM'} size="small">
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item label="Nama Kategori" name="name" rules={[{ required: true, message: 'Nama kategori harus diisi' }]}>
            <Input />
          </Form.Item>

          <Form.Item label="Deskripsi" name="description">
            <TextArea rows={4} />
          </Form.Item>

          <Form.Item label="Gambar">
            <Upload listType="picture" fileList={fileList} beforeUpload={() => false} onChange={({ fileList }) => setFileList(fileList)} maxCount={1}>
              <Button icon={<UploadOutlined />}>Upload Gambar</Button>
            </Upload>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
              Simpan
            </Button>
            <Button onClick={() => navigate('/umkm-category')}>Batal</Button>
          </Form.Item>
        </Form>
      </Card>
    </ContentWithErrorHandler>
  );
}

export default UmkmCategoryDetail;
